// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sparkline maps */

/*   muted country boundaries */
.em--spark .em-cntbn {
    stroke: rgb(163, 163, 163);
    stroke-width: 0.2px;
}

.em--spark #em-cntbn-halo {
    stroke: none;
}

/*   muted nuts boundaries */
.em--spark .em-bn-1,
.em--spark .em-bn-2,
.em--spark .em-bn-3,
.em--spark .em-nutsrg [lvl='3'],
.em--spark .em-nutsrg [lvl='2'],
.em--spark .em-nutsrg [lvl='1'],
.em--spark .em-bn-co {
    stroke-width: 0.05px;
}

/*  muted country fill */
.em--spark .em-cntrg {
    fill: #f2f2f2;
}

/*  nuts fill (regions with data) */
.em--spark .em-nutsrg {
    fill: #fffef3;
    /*fill: #c9ffd524;  very light green */
    /*fill: #fffee724;  very light yellow */
}

/*  regions without data input */
.em--spark [ecl='ni'] {
    fill: #e9e9e9;
}

/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */
/* .em--spark g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {
    stroke-width: 0px;
} */

/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */
.em--spark .em-bn-co {
    stroke: grey;
    stroke-width: 0.05px;
}
`, "",{"version":3,"sources":["webpack://./src/css/map-types/sparkline.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,+BAA+B;AAC/B;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;;;;;;;IAOI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA,mCAAmC;AACnC;IACI,aAAa;IACb,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,uHAAuH;AACvH;;GAEG;;AAEH,0HAA0H;AAC1H;IACI,YAAY;IACZ,oBAAoB;AACxB","sourcesContent":["/* Sparkline maps */\r\n\r\n/*   muted country boundaries */\r\n.em--spark .em-cntbn {\r\n    stroke: rgb(163, 163, 163);\r\n    stroke-width: 0.2px;\r\n}\r\n\r\n.em--spark #em-cntbn-halo {\r\n    stroke: none;\r\n}\r\n\r\n/*   muted nuts boundaries */\r\n.em--spark .em-bn-1,\r\n.em--spark .em-bn-2,\r\n.em--spark .em-bn-3,\r\n.em--spark .em-nutsrg [lvl='3'],\r\n.em--spark .em-nutsrg [lvl='2'],\r\n.em--spark .em-nutsrg [lvl='1'],\r\n.em--spark .em-bn-co {\r\n    stroke-width: 0.05px;\r\n}\r\n\r\n/*  muted country fill */\r\n.em--spark .em-cntrg {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/*  nuts fill (regions with data) */\r\n.em--spark .em-nutsrg {\r\n    fill: #fffef3;\r\n    /*fill: #c9ffd524;  very light green */\r\n    /*fill: #fffee724;  very light yellow */\r\n}\r\n\r\n/*  regions without data input */\r\n.em--spark [ecl='ni'] {\r\n    fill: #e9e9e9;\r\n}\r\n\r\n/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */\r\n/* .em--spark g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {\r\n    stroke-width: 0px;\r\n} */\r\n\r\n/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */\r\n.em--spark .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.05px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
